/**
 * Controls layer constants
 * 定数の一元管理により保守性を向上
 */

// ドラッグ操作関連の定数
export const DRAG_CONSTANTS = {
  // 確定しきい値(セルサイズの%) - 軽いタッチ対応
  CONFIRM_RATIO: 0.25,

  // 無効スワップ後のクールダウン(ms) - テンポ重視
  INVALID_SWAP_COOLDOWN: 60,
};

// スキル操作関連の定数
export const SKILL_CONSTANTS = {
  // スキル範囲（5x5エリア）
  SKILL_RADIUS: 2,

  // プレビューアニメーション
  PREVIEW_DELAY_BASE: 40, // 基本遅延(ms)
  PREVIEW_DELAY_RATIO: 120, // 距離比例遅延(ms)
  PREVIEW_DURATION: 350, // プレビュー表示時間(ms)

  // ボタンアニメーション
  BUTTON_SCALE_DOWN: 0.96, // 押下時のスケール
  BUTTON_SCALE_NORMAL: 1, // 通常時のスケール
  BUTTON_ANIMATION_DURATION: 90, // アニメーション時間(ms)

  // 操作制御
  OPERATION_TIMEOUT: 5000, // 操作ロックタイムアウト(ms)
  DEBOUNCE_DELAY: 100, // デバウンス遅延(ms)

  // 通信タイムアウト
  PROBE_TIMEOUT: 1000, // セル検証タイムアウト(ms)
  CONSUME_TIMEOUT: 1000, // スキル消費タイムアウト(ms)
  ANIMATION_TIMEOUT: 60000, // アニメーション完了タイムアウト(ms)
};

// UI設定関連の定数
export const UI_CONSTANTS = {
  // ランキング表示
  RANKING_DISPLAY_COUNT: 50,
  TOP_RANK_THRESHOLD: 3,

  // 統計初期値
  PLAY_COUNT_INITIAL: 0,

  // ナビゲーション
  NAVIGATION_HOME_INDEX: -1,
};

// ポインタ制御関連の定数
export const POINTER_CONSTANTS = {
  // 主ポインタID（多指制御用）
  PRIMARY_POINTER_IDS: [0, 1],

  // 隣接判定
  ADJACENT_DISTANCE: 1,
};

// DOM操作関連の定数
export const DOM_CONSTANTS = {
  // 要素セレクタ
  PIECE_SHADOW_SELECTOR: '.piece-shadow',
  TABLE_CELL_SELECTOR: 'td',

  // データ属性
  DATA_COL: 'data-col',
  DATA_ROW: 'data-row',
  DATA_START_X: 'data-start-x',
  DATA_START_Y: 'data-start-y',
  DATA_X: 'data-x',
  DATA_Y: 'data-y',

  // CSSクラス
  SKILL_TARGETING_CLASS: 'is-skill-targeting',
  SKILL_ARMED_CLASS: 'is-armed',
  SKILL_PREVIEW_CLASS: 'skill-preview',
  DRAWER_OPEN_CLASS: 'is-drawer-open',
  CLICKED_CLASS: 'clicked',
  ACTIVE_CLASS: 'is-active',

  // CSS変数
  SKILL_PREVIEW_DELAY_VAR: '--skill-preview-delay',
  SKILL_TRANSLATE_X_VAR: '--skill-translateX',

  // ARIA属性
  ARIA_PRESSED: 'aria-pressed',
};
